// @flow
import * as React from 'react';
import { DragSource } from 'react-dnd';
import { compose } from 'redux';
import { withStyles } from '@mui/styles';
import sourceSheet from './sourceSheet';
import cn from 'classnames';

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  isDragging: boolean,
  withMinimizedPreview: boolean,
  connectDragSource: Function,
  connectDragPreview: Function,
  // eslint-disable-next-line react/no-unused-prop-types
  readOnly: boolean,
  // eslint-disable-next-line react/no-unused-prop-types
  id?: string,
  params?: { linkid?: string },
  className?: string,
  classes: { [key: string]: string },
  children: React$Node,
  onEndDrag?: () => void,
  onBeginDrag?: () => void,
};

class DraggableSource extends React.PureComponent<Props> {
  previewRef: ?HTMLElement;

  componentDidMount(): * {
    const { connectDragPreview } = this.props;
    connectDragPreview(this.previewRef);
  }

  get isMinimizedPreview() {
    const { children, withMinimizedPreview } = this.props;

    return children && children.props && withMinimizedPreview;
  }

  get isLinkid() {
    const { children } = this.props;

    if (!(children && children.props)) return false;
    const {
      children: {
        props: { document },
      },
      params,
    } = this.props;
    return document && params && !params.linkid && document.linkid;
  }

  get isMultipleDocumentsSelected() {
    const { children } = this.props;
    if (!(children && children.props)) return false;
    const {
      children: { props },
    } = this.props;
    return props.selected && props.selectedDocumentsSize > 1;
  }

  render() {
    const { connectDragSource, className, isDragging, children, classes } = this.props;
    return connectDragSource(
      <div className={className} style={{ opacity: isDragging ? 0.3 : 1 }}>
        {children}
        {this.isMinimizedPreview ? (
          <div className={classes.wrapper}>
            <div
              className={cn(classes.preview, {
                // $FlowFixMe
                [classes.selected]: this.isMultipleDocumentsSelected,
                [classes.linkid]: this.isLinkid,
              })}
              ref={(el) => {
                this.previewRef = el;
              }}
            >
              {
                // $FlowFixMe
                children.props.previewSrc ? (
                  <img className={classes.previewImg} src={children.props.previewSrc} alt="" />
                ) : null
              }
            </div>
          </div>
        ) : null}
      </div>,
    );
  }
}

const draggableSource = (itemType: string) => ({
  beginDrag(props: Props) {
    const { id, params = {}, onBeginDrag } = props;
    // eslint-disable-next-line no-unused-expressions
    onBeginDrag && onBeginDrag();
    return { id, ...params, itemType };
  },
  isDragging(props: Props, monitor) {
    return monitor.getItem().id === props.id;
  },
  canDrag(props: Props) {
    return !props.readOnly;
  },
  endDrag({ onEndDrag }: Props, monitor) {
    if (onEndDrag) {
      onEndDrag(monitor.getDropResult());
    }
  },
});

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

export const DnDItemSource = (name: string) =>
  compose(DragSource(name, draggableSource(name), collect), withStyles(sourceSheet))(DraggableSource);
